import { attr, FASTElement, observable } from '@microsoft/fast-element';
import { formFieldStyles } from './form-field.styles';
import { formFieldTemplate } from './form-field.template';
import { NatGenDesignSystem } from '../../natgen-design-system';

/**
 * @element natgen-form-field
 */
export class NatGenFormField extends FASTElement {
    @attr label: string;
    @attr orientation: 'center' | 'left' | 'right' = 'left';
    // TODO: Allow for control of tooltip placement?
    @observable slottedTooltipNodes: Node[];
}

export const natGenFormFieldDefinition = NatGenFormField.compose({
    name: `${NatGenDesignSystem.prefix}-form-field`,
    template: formFieldTemplate,
    styles: formFieldStyles
});
